import { searchBlueprintSuggestionsDictionary } from "shared/Blueprint/constants";
import makeUseCellFilterAction, {
  UseCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseCellFilterAction";

import useBlueprintsAnalytics from "../hooks/useBlueprintsAnalytics";

const useCellFilterAction = (props: UseCellFilterActionProps) => {
  return makeUseCellFilterAction({
    trackAnalytics: useBlueprintsAnalytics(),
    searchSuggestionsDictionary: searchBlueprintSuggestionsDictionary,
  })(props);
};

export default useCellFilterAction;
